import React, { useMemo } from "react";
import {
    Redirect,
    Route,
    RouteComponentProps,
    Switch,
    useHistory
} from "react-router-dom";
import CourseLayout from "./components/CourseLayout";
import Resource from "./Resource";
import SignIn from "./SignIn";
import RollCall from "./RollCall";
import Vote from "./Vote";
import Exercise from "./Exercise";
import Homework from "./Homework";
import SignInDetail from "./SignInDetail";
import useRequest from "utils/useRequest";
import {
    CourseItem,
    getCourseData,
    isTrue,
    liveState,
    StudentType,
    toNumber,
    workState
} from "service/service";
import _ from "underscore";

import CourseSpin from "./components/CourseSpin";
import { LayoutRoute } from "components/LayoutRoute";
import { CourseContext } from "./Store";
import VoteDetail from "./VoteDetail";
import Experiment from "./Experiment";
import Report from "./Report";
import ExerciseTopics from "./ExerciseTopics";
import ExerciseDetail from "./ExerciseDetail";
import ExerciseStatics from "./ExerciseStatics";
import ExerciseStudents from "./ExerciseStudents";
import CourseChapters from "./CourseChapters/Index";
import ResourceStatistics from "./ResourceStatistics";
import { getCourseInfo, HaveWeekTime } from "../../service/course";
import { courseDetailUrlNoWeekId } from "../../service/url";
import ChaptersLayout from "./components/ChaptersLayout";
import Group from "./Group";
import GroupSettings from "./GroupSettings";
import GroupDetail from "./GroupDetail";
import useCurrentDate from "../../utils/useCurrentDate";
import Meeting from "./Meeting";
import Question from "./Question";
import QuestionTopics from "./Question/Topics";
import QuestionDetail from "./Question/Detail";
import QuestionStatic from "./Question/Statics";
import QuestionStudent from "./Question/Students/index";
import DiscussList from "./Discuss/DiscussList";
import { DiscussDetail } from "./Discuss/DiscussDetail";

export interface CourseDetailProps {
    weekTimeId: string;
    courseSeq: string;
    courseNo: string;
    batchNo: string;
}

export default function CourseDetail({
    match
}: RouteComponentProps<CourseDetailProps>) {
    const history = useHistory();
    const Current = useCurrentDate();
    const { weekTimeId, courseSeq, courseNo, batchNo } = match.params;
    const [CourseData, {}, updateCourses] = useRequest(
        () => getCourseData({}),
        {},
        []
    );
    const [CourseInfo, { loading: infoLoading }] = useRequest(
        () => getCourseInfo({ batchNo, courseNo, courseSeq }),
        {},
        [weekTimeId, courseSeq, courseNo, batchNo]
    );
    const course = useMemo(() => {
        if (toNumber(weekTimeId) !== HaveWeekTime.no) {
            return _.find(CourseData || [], {
                weekTimeId: toNumber(weekTimeId)
            });
        } else {
            const o: CourseItem = {
                address: "",
                beginTime: "",
                channelId: "",
                chapterId: "",
                className: "",
                continunity: "",
                courseId: "",
                courseName: CourseInfo?.courseName || "",
                courseUniqueId: "",
                courseUrl: "",
                date: "",
                day: "",
                endTime: "",
                isCloud: liveState.IsLive,
                isLive: liveState.NoIsLive,
                isOpen: undefined,
                isPublish: undefined,
                key: 0,
                lmsCourseNo: "",
                month: "",
                platformType: "",
                section: "",
                type: StudentType.MBA,
                week: "",
                workstate: workState.HaveHomework,
                weekTimeId: toNumber(weekTimeId),
                courseSeq,
                courseNo,
                batchNo: batchNo as string
            };
            return o;
        }
    }, [weekTimeId, CourseData, courseSeq, courseNo, batchNo, CourseInfo]);

    // 不考虑无课程的情况
    if (!course || infoLoading) return <CourseSpin />;

    if (batchNo) {
        course.batchNo = batchNo;
    } else {
        course.batchNo = Current.batchNo;
    }

    const basename = courseDetailUrlNoWeekId(course as CourseItem, "");
    // 模块路径
    const path = history.location.pathname.substr(basename.length + 1);

    return (
        <CourseContext.Provider
            value={{ course, basename, updateCourses, path }}>
            <Switch>
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/resource/:sourceId`}
                    exact
                    component={ResourceStatistics}
                />

                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/resource`}
                    exact
                    component={Resource}
                    layout={CourseLayout}
                />

                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/signin`}
                    exact
                    component={SignIn}
                    layout={CourseLayout}
                />
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/signInDetail/:signInId`}
                    exact
                    component={SignInDetail}
                />

                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/rollcall`}
                    exact
                    component={RollCall}
                    layout={CourseLayout}
                />

                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/discuss`}
                    exact
                    component={DiscussList}
                    layout={CourseLayout}
                />

                <Route
                    key={course.weekTimeId}
                    path={`${basename}/discuss/:uuid`}
                    exact
                    component={DiscussDetail}
                />

                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/vote`}
                    exact
                    component={Vote}
                    layout={CourseLayout}
                />
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/vote/:voteId`}
                    exact
                    component={VoteDetail}
                />

                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/exercise`}
                    exact
                    component={Exercise}
                    layout={CourseLayout}
                />
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/exercise/topics/:id`}
                    exact
                    component={ExerciseTopics}
                />
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/exercise/detail/:exerciseId`}
                    exact
                    component={ExerciseDetail}
                />
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/exercise/statics/:exerciseId`}
                    exact
                    component={ExerciseStatics}
                />
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/exercise/students/:exerciseId`}
                    component={ExerciseStudents}
                />
                {/*章节编辑*/}
                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/courseChapters`}
                    exact
                    component={CourseChapters}
                    layout={ChaptersLayout}
                />
                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/homework`}
                    exact
                    component={Homework}
                    layout={CourseLayout}
                />
                {/* 小组 */}
                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/group`}
                    exact
                    component={Group}
                    layout={CourseLayout}
                />
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/group/settings/:flag?`}
                    exact
                    component={GroupSettings}
                />
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/group/detail/:activityId?`}
                    component={GroupDetail}
                />

                {isTrue(course.isCloud) && (
                    <LayoutRoute
                        key={course.weekTimeId}
                        path={`${basename}/experiment`}
                        exact
                        component={Experiment}
                        layout={CourseLayout}
                    />
                )}
                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/report`}
                    exact
                    component={Report}
                    layout={CourseLayout}
                />
                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/meeting`}
                    exact
                    component={Meeting}
                    layout={CourseLayout}
                />

                {/* 问卷 */}
                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/question`}
                    exact
                    component={Question}
                    layout={CourseLayout}
                />
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/question/topics/:id`}
                    exact
                    component={QuestionTopics}
                />
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/question/detail/:questionnaireId`}
                    exact
                    component={QuestionDetail}
                />
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/question/static/:questionnaireId`}
                    exact
                    component={QuestionStatic}
                />
                <Route
                    key={course.weekTimeId}
                    path={`${basename}/question/students/:questionnaireId`}
                    component={QuestionStudent}
                />

                <Redirect to={`${basename}/resource`} />
            </Switch>
        </CourseContext.Provider>
    );
}
